module.exports = __webpack_public_path__ + "img/LOGO_preto.4aa4c30e.png";